import React from 'react';
import { useTranslation } from 'react-i18next';

export type BackCapturePillProps = {
  captureMode?: 'live' | 'back_capture' | undefined;
  capturedByName?: string;
  backCaptureBeyondLimit?: boolean;
};

const BackCapturePill: React.FC<BackCapturePillProps> = ({
  captureMode,
  capturedByName,
  backCaptureBeyondLimit,
}) => {
  const { t } = useTranslation();
  if (captureMode !== 'back_capture') return null;

  return (
    <>
      <span className="pat-status-pill pat-status-pill--info" data-testid="back-capture-pill">
        <i className="bi bi-pencil-square" aria-hidden="true" />
        {' '}
        {t('spray.backCapture.pill.label')}
        {capturedByName && (
          <>{' '}{t('spray.backCapture.pill.byName', { name: capturedByName })}</>
        )}
      </span>
      {backCaptureBeyondLimit && (
        <span
          className="pat-status-pill pat-status-pill--warn"
          data-testid="back-capture-pill-beyond"
          style={{ marginLeft: '0.25rem' }}
        >
          {t('spray.backCapture.pill.beyondLimit')}
        </span>
      )}
    </>
  );
};

export default BackCapturePill;
